import { useStore } from "../state/store";

function parseUtc(iso: string): Date {
  return new Date(/[zZ]|[+-]\d\d:?\d\d$/.test(iso) ? iso : iso + "Z");
}

// Data-freshness honesty, promoted from 12px panel text to a map-wide banner.
// Rendered over the canvas in EVERY mode that shows live data (Live itself and
// the climatology Gateway overlay) — a user staring at the map mid-landfall
// must not need to find the side panel to learn the feed is down.
export default function StalenessBanner() {
  const mode = useStore((s) => s.mode);
  const climoOverlay = useStore((s) => s.climoOverlay);
  const bundle = useStore((s) => s.live.bundle);
  const error = useStore((s) => s.live.error);
  const indexKind = useStore((s) => s.live.indexKind);

  const liveDataVisible = mode === "live" || (mode === "climatology" && climoOverlay);
  if (!liveDataVisible) return null;

  // Severity: stale cached bundle > feed error > old best-track fix.
  let msg: string | null = null;
  let color = "#F59E0B";
  if (bundle?.stale) {
    msg = "⚠ NHC feed unreachable — showing the last cached data for this storm.";
    color = "#EF4444";
  } else if (error) {
    msg = `⚠ ${error}`;
    color = indexKind === "demo" ? "#F59E0B" : "#EF4444";
  } else if (bundle && !bundle.source.includes("archive") && bundle.source !== "seed") {
    const last = bundle.best_track[bundle.best_track.length - 1];
    if (last?.dt) {
      const hours = (Date.now() - parseUtc(last.dt).getTime()) / 3600000;
      if (hours > 9) {
        msg = `⚠ Last observed fix is ${Math.round(hours)}h old — position/intensity may have changed.`;
      }
    }
  }
  if (!msg) return null;

  return (
    <div
      style={{
        position: "absolute", top: 0, left: 0, right: 0, zIndex: 12,
        background: `${color}26`, borderBottom: `1px solid ${color}`,
        color: "white", font: "600 12px Inter, sans-serif",
        padding: "7px 14px", textAlign: "center", backdropFilter: "blur(4px)",
      }}
    >
      {msg}
    </div>
  );
}
